(() => {
  const panel = document.querySelector('[data-hyde-buyer-help]');
  if (!panel || !/^\d{5}$/.test(panel.dataset.model)) return;
  const key = 'hyde-buying-help-dismissed-v1';
  let suppressed = false;
  try { suppressed = sessionStorage.getItem(key) === '1'; } catch (_) {}
  if (suppressed) return;
  const started = Date.now();
  let engaged = false;
  const form = document.getElementById('hyde-trove-atc-form');
  const buybox = document.querySelector('.hyde-buybox');
  const quantity = () => {
    const value = Number(form?.querySelector('[name="quantity"]')?.value);
    return Number.isInteger(value) && value >= 1 && value <= 999 ? value : 1;
  };
  function dismiss() {
    suppressed = true;
    panel.hidden = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  }
  function updateContext() {
    const qty = quantity();
    const crew = qty > 1;
    panel.querySelector('[data-help-title]').textContent = crew ? 'Buying for a crew—or stocking up?' : 'One fit question before you order?';
    panel.querySelector('[data-help-copy]').textContent = crew ? 'Keep this exact model and quantity in an editable list, or ask about supply, delivery and purchasing requirements.' : 'Tell us which tool or setup you use. Confirm compatibility and what else you need before ordering.';
    const contact = panel.querySelector('[data-help-contact]');
    contact.href = `/pages/contact?model=${panel.dataset.model}&quantity=${qty}&topic=${crew ? 'crew' : 'fit'}#ContactForm`;
    contact.textContent = crew ? 'Ask about this crew order →' : 'Ask about this model →';
    panel.querySelector('[data-help-list]').href = `/pages/order-pad?items=${panel.dataset.model}:${qty}`;
  }
  function show(desktopReading = false) {
    if (suppressed || (!engaged && !desktopReading) || document.visibilityState !== 'visible' || !panel.hidden) return;
    updateContext();
    panel.hidden = false;
  }
  panel.querySelector('[data-help-dismiss]').addEventListener('click', dismiss);
  panel.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { updateContext(); dismiss(); }));
  form?.addEventListener('submit', dismiss);
  document.querySelectorAll('[data-hyde-tier]').forEach(button => button.addEventListener('click', () => {
    engaged = true;
    if (!panel.hidden) setTimeout(updateContext, 0);
  }));
  window.addEventListener('scroll', () => { if (window.scrollY > 150) engaged = true; }, {passive:true});
  document.addEventListener('mouseout', event => {
    if (!event.relatedTarget && event.clientY <= 0 && matchMedia('(min-width:1101px) and (hover:hover)').matches && Date.now() - started >= 15000) show(true);
  });
  const timer = setInterval(() => {
    if (suppressed || !panel.hidden) { clearInterval(timer); return; }
    if (Date.now() - started < 45000 || !engaged || !buybox) return;
    const rect = buybox.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < window.innerHeight && !matchMedia('(min-width:1101px)').matches) show();
  }, 3000);
})();
